<template>
  <div class="page_internalInvoice">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>收支</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/invoicing' }">开票</el-breadcrumb-item>
          <el-breadcrumb-item>内部开票</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <div class="p_employee_box">
          <!-- 开票抬头 -->
          <div class="p_employee_list">
            <div class="flex aic">
              <div class="r_edit_title">
                <div class="line_box"></div>
                开票抬头
              </div>
            </div>
            <div class="seller">
              我方法务实体: {{ basicInfo.seller }}
            </div>
            <div class="com_style pt20">
              <el-form :inline="true" ref="statementForm1" label-width="110px">
                <el-form-item label="对方开票抬头:">
                  <div class="form_item">
                    {{ basicInfo.purchaser }}
                  </div>
                </el-form-item>
                <el-form-item label="最近开票金额:">
                  <div class="form_item">
                    {{ basicInfo.amount }}
                  </div>
                </el-form-item>
                <el-form-item label="开票日期:">
                  <div class="form_item">
                    {{ basicInfo.lastBillTime }}
                  </div>
                </el-form-item>
                <el-form-item label="纳税人识别号:">
                  <div class="form_item">
                    {{ basicInfo.taxpayerNumber }}
                  </div>
                </el-form-item>
                <el-form-item label="营业地址:">
                  <div class="form_item">
                    {{ basicInfo.businessAddress }}
                  </div>
                </el-form-item>
                <el-form-item label="开户行:">
                  <div class="form_item">
                    {{ basicInfo.depositBank }}
                  </div>
                </el-form-item>
                <el-form-item label="账号:">
                  <div class="form_item">
                    {{ basicInfo.accountNumber }}
                  </div>
                </el-form-item>
                <el-form-item label="电话:">
                  <div class="form_item">
                    {{ basicInfo.telephone }}
                  </div>
                </el-form-item>
              </el-form>
            </div>
            <div class="Amount">
              待开金额:
              <span class="redFont">
                ￥{{ basicInfo.outstandingAmount }}
              </span>
              <span class="otherAmount">（内部结算金额小计￥{{basicInfo.subtotal}}：转款￥{{basicInfo.amount}}，个税{{basicInfo.tax}}，服务费￥{{basicInfo.serviceCharge}}）</span>
            </div>
            <!-- <div>开票总额{{ totalAmount }}</div> -->
          </div>

          <div class="mt15">
            <div class="flex aic">
              <div class="r_edit_title">
                <div class="line_box"></div>
                填写开票内容
              </div>
            </div>

            <el-form :model="formQuery" :inline="true" :rules="formRules" ref="formQuery" label-width="80px">
              <div class="com_style pt20 mt15" v-for="(inv,i) in formQuery.details" :key="i">
                <div>
                  <el-form-item label="开票方式:">
                    <el-select class="f_sel01" v-model="inv.billingItemId" placeholder="" size="small" filterable clearable @change="val=>{changeBilling(val,inv,i)}" style="width: 180px;">
                      <el-option v-for="(item, index) in BillingList" :key="index" :label="item.value" :value="item.key"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="票种:">
                    <el-select v-model="inv.ticketTypeId" placeholder="" size="small" style="width: 180px" filterable clearable value-key="key" @change="val=>{changeTicketTypeId(val,inv, i)}">
                      <el-option v-for="(item, index) in ticketTypeList[i].list" :key="index" :label="item.value" :value="item.key"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="特殊要求:" v-if="inv.billingItemName.indexOf('差额') > -1">
                    <el-checkbox v-model="inv.isMerge" @change="val=>{changeMerge(val,inv)}">合并开票</el-checkbox>
                  </el-form-item>
                </div>
                <!-- 全额部分 -->
                <div v-if="inv.billingItemName.indexOf('全额') > -1">
                  <div v-for="(bi,j) in inv.main" :key="j">
                    <el-form-item label="开票内容:">
                      <el-select class="f_sel01" v-model="bi.billingItemDetailsId" placeholder="" size="small" filterable clearable style="width: 180px;" @change="val=>{changeBillingItemDetailsId(val,bi,i)}">
                        <el-option v-for="(item, index) in BillingConList[i].list" :key="index" :label="item.value" :value="item.key"></el-option>
                      </el-select>
                    </el-form-item>

                    <el-form-item label="开票金额:" type="number">
                      <el-select v-model="bi.isTaxInclusive" placeholder="" size="small" @change="val=>{calMtpt(val,inv)}" style="width: 85px;margin-right: 10px">
                        <el-option label="含税" :value="true"></el-option>
                        <el-option label="不含税" :value="false"></el-option>
                      </el-select>
                      <el-input v-model="bi.invoiceAmount" @blur="calMtpt('',inv)" size="small" style="width: 95px"></el-input>
                    </el-form-item>

                    <el-form-item label="项目申报代码:" label-width="110px">
                      <el-select v-model="bi.pk" placeholder="" size="small" style="width: 180px" filterable value-key="key">
                        <el-option v-for="(item, index) in projectKeyList[i].list" :key="index" :label="item.value" :value="item.key"></el-option>
                      </el-select>
                    </el-form-item>
                    <!-- <el-form-item label="数量:" label-width="50px">
                      <el-input type="number" v-model="bi.replenishment.quantity" size="small" style="width: 70px;"></el-input>
                    </el-form-item>
                    <el-form-item label="单位:" label-width="50px">
                      <el-input v-model="bi.replenishment.unit" size="small" style="width: 70px;"></el-input>
                    </el-form-item>
                    <el-form-item label="规格:" label-width="50px">
                      <el-input v-model="bi.replenishment.specification" size="small" style="width: 70px;"></el-input>
                    </el-form-item> -->
                    <el-form-item>
                      <div class="injuryTabBtn">
                        <el-button type="text" @click="addContentHandle(inv)">+ 添加</el-button>
                        <el-button type="text" v-if="j!=0" @click="dltContentHandle(inv,j)">删除</el-button>
                      </div>
                    </el-form-item>
                  </div>
                  <div class="mTpt">
                    <el-form-item label="价税合计:" label-width="80px">
                      <span style="font-weight: bold">￥{{ inv.mTpt.toFixed(2) }}</span>
                    </el-form-item>
                  </div>
                </div>

                <!-- 差额部分 -->
                <div v-if="inv.billingItemName.indexOf('差额开票') > -1">
                  <div>
                    <!-- 不合并 -->
                    <el-form-item label="开票内容:" v-if="!inv.isMerge">
                      <el-select class="f_sel01" v-model="inv.takeOut.billingItemDetailsId" placeholder="" size="small" filterable clearable style="width: 180px;" @change="val=>{changeBillingItemDetailsId(val,inv.takeOut,i)}">
                        <el-option v-for="(item, index) in BillingConList[i].list" :key="index" :label="item.value" :value="item.key"></el-option>
                      </el-select>
                    </el-form-item>

                    <!-- 合并 -->
                    <el-form-item label="开票内容:" v-if="inv.isMerge">
                      <el-select class="f_sel01" v-model="inv.main[0].billingItemDetailsId" placeholder="" size="small" filterable clearable style="width: 180px;" @change="val=>{changeBillingItemDetailsId(val,inv.main[0],i)}">
                        <el-option v-for="(item, index) in BillingConList[i].list" :key="index" :label="item.value" :value="item.key"></el-option>
                      </el-select>
                    </el-form-item>

                    <el-form-item label="开票金额（服务费）:" v-if="inv.isMerge" type="number" label-width="145px">
                      <el-select v-model="inv.main[0].isTaxInclusive" placeholder="" @change="val=>{calDeductionAmountSum(val,inv)}" size="small" style="width: 85px;margin-right: 10px">
                        <el-option label="含税" :value="true"></el-option>
                        <el-option label="不含税" :value="false"></el-option>
                      </el-select>
                      <el-input v-model="inv.main[0].invoiceAmount" @blur="calDeductionAmountSum('',inv)" size="small" style="width: 95px"></el-input>
                    </el-form-item>

                    <el-form-item label="项目申报代码:" label-width="110px">
                      <el-select v-model="inv.takeOut.pk" placeholder="" size="small" style="width: 180px" filterable clearable value-key="key">
                        <el-option v-for="(item, index) in projectKeyList[i].list" :key="index" :label="item.value" :value="item.key"></el-option>
                      </el-select>
                    </el-form-item>

                    <!-- <el-form-item label="数量:" label-width="50px">
                      <el-input type="number" v-model="inv.takeOut.replenishment.quantity" size="small" style="width: 70px;"></el-input>
                    </el-form-item>
                    <el-form-item label="单位:" label-width="50px">
                      <el-input v-model="inv.takeOut.replenishment.unit" size="small" style="width: 70px;"></el-input>
                    </el-form-item>
                    <el-form-item label="规格:" label-width="50px">
                      <el-input v-model="inv.takeOut.replenishment.specification" size="small" style="width: 70px;"></el-input>
                    </el-form-item> -->
                  </div>

                  <div class="deductionBox" v-for="(de,j) in inv.takeOut.details" :key="j">
                    <el-form-item label="扣除项目:">
                      <el-input v-model="de.projectName" size="small" style="width: 180px;"></el-input>
                    </el-form-item>
                    <el-form-item label="扣除金额:">
                      <el-input type="number" v-model="de.deductionAmount" size="small" style="width: 180px;" @blur="calDeductionAmountSum('',inv)"></el-input>
                    </el-form-item>
                    <el-form-item>
                      <div class="injuryTabBtn">
                        <el-button type="text" @click="addKcItem(inv)">+ 添加</el-button>
                        <el-button type="text" v-if="j!=0" @click="delKcItem(inv,j)">删除</el-button>
                      </div>
                    </el-form-item>
                  </div>

                  <div class="mTpt">
                    <el-form-item label="价税合计:" label-width="80px">
                      <span style="font-weight: bold">￥{{ inv.mTpt.toFixed(2) }}</span>
                    </el-form-item>
                  </div>
                </div>
              </div>

              <div class="flex mt15">
                <div class="applyMore blueName cp" @click="applyMore()">+再开一张发票</div>

                <div class="applyMore deleteBtn cp" v-if="formQuery.details.length>1" @click="delItem()">
                  <i class="el-icon-delete delete_icon"></i>
                  删除
                </div>
              </div>
            </el-form>
          </div>

          <div class="chkBox">
            <el-checkbox v-model="formQuery.sfzsxsfyhzh">是否展示销售方银行信息</el-checkbox>
            <el-checkbox v-model="formQuery.sfzsgmfyhzh">是否展示购买方银行信息</el-checkbox>
            <el-checkbox v-model="formQuery.isautoremark">是否显示备注</el-checkbox>
          </div>

          <div class="r_edit_title" style="margin-top: 25px">
            <div class="line_box"></div>
            可用额度
          </div>
          <div class="flex aic" v-loading="limltIng" element-loading-text="正在查询可用额度">
            <div class="flex">
              <div class="limltTitle">可用授信额度：</div>
              <div class="limlt">{{kysxed}}</div>
              <div class="limltTitle">总授信额度：</div>
              <div class="limlt">{{zsxed}}</div>
              <div class="limltTitle">当前可用纸票数量：</div>
              <div class="limlt">{{dqkyzpsl}}</div>
            </div>

            <el-button type="success" size="small" @click="getLimit()" v-preventReClick>重新查询</el-button>
          </div>
          <div class="cwxx">{{ cwxx }}</div>
          <div class="limltBox" v-if="limltIng"></div>

          <!-- 开票无申请 -->
          <div class="btn_box">
            <el-button type="success" @click="beforeSubmit(false)" :loading="isBtnLoading" v-preventReClick>在线开票</el-button>
            <el-button type="primary" @click="beforeSubmit(true)" v-preventReClick :loading="isBtnLoading">登记手工开票</el-button>
            <el-button @click="backHandle">取消</el-button>
          </div>
        </div>
      </div>
    </div>


    <el-dialog title="登录" :visible.sync="showLogin" width="530px" class="res_dialog enter_dialog">
      <el-form :model="loginForm" :rules="loginRules" ref="loginForm" class="re_down_form" label-width="100px">
        <el-form-item label="法务主体:">
          {{ loginForm.qymc }}
        </el-form-item>
        <el-form-item label="税号:">
          <el-input v-model="loginForm.nsrsbh" size="small" clearable style="width: 300px"></el-input>
        </el-form-item>
        <el-form-item label="手机号:" prop="zrrsjh">
          <el-input v-model="loginForm.zrrsjh" size="small" clearable style="width: 300px"></el-input>
        </el-form-item>
        <el-form-item label="登录密码:" prop="zrrmm">
          <el-input v-model="loginForm.zrrmm" size="small" clearable style="width: 300px"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showLogin = false" size="small">取消</el-button>
        <el-button type="primary" @click="confirmLogin" size="small" :loading="isBtnLoading">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="认证" :visible.sync="showAuthentication" width="450px">
      <div :loading="qrLoading">
        <el-form>
          <el-form-item label="二维码类型:">
            <el-select v-model="ewmlx" size="small" @change="changeEwmlx" placeholder="" style="width: 180px;">
              <el-option label="税务APP" :value="1">
              </el-option>
              <el-option label="个税APP" :value="2">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <el-image style="width: 300px; height: 300px;margin-left:50px" v-if="QRCodeSrc" :src="QRCodeSrc" alt="" @click="getQRCode"></el-image>
      <div class="qrTips" v-if="qrLoading">二维码加载中...</div>
      <!-- <el-button>重新获取二维码</el-button> -->
      <div v-if="isTimeout" class="qrTips">网络连接超时或异常</div>
      <div class="qrTips" v-if="ewmlx && !qrLoading">请使用{{ewmlx==1?'税务APP' : '个税APP'}}扫码认证</div>
      <!-- <div @click="getQRStatus">111</div> -->
    </el-dialog>
  </div>
</template>

<script>
  import xz from "../../common";
  import * as math from 'mathjs'
  export default {
    data() {
      return {
        isBtnLoading: false,
        formQuery: {
          remitIds: [], //打款id
          drawer: Cookies.get("userid-b"), //开票人
          remark: '', //开票备注
          details: [{
            index: 1,
            billingItemId: '', //开票方式
            isMerge: false, //是否合并
            ticketTypeId: '', //票种
            taxRate: null,
            billingItemName: '',
            mTpt: 0,
            projectKey: '', //项目申报代码
            main: [{
              billingItemDetailsId: '', //开票内容id
              isTaxInclusive: true, //是否含税
              invoiceAmount: 0, //开票金额
              // replenishment: {
              //   quantity: null,
              //   unit: '',
              //   specification: ''
              // }
            }],
            takeOut: {
              billingItemDetailsId: '',
              pk: '',
              // replenishment: {
              //   quantity: null,
              //   unit: '',
              //   specification: ''
              // },
              details: [{
                projectName: '', //扣除项目
                deductionAmount: 0
              }]
            }
          }],
          isOffline: false, //是否线下申请（手工开票
          sfzsxsfyhzh: true, //是否在展示销售方银行信息
          sfzsgmfyhzh: false, //是否展示购买方银行信息
          isautoremark: true, //是否显示备注
          gmfxxsfqr: false, //购买方信息是否确认
          sxeddefptxgz: false, //是否确认开具大额发票
          spflxqr: false //是否确认受票方为单位
        },
        formRules: {},
        basicInfo: {
          seller: "",
          purchaser: "",
          taxpayerNumber: "",
          businessAddress: "",
          depositBank: "",
          accountNumber: "",
          telephone: "",
          outstandingAmount: null,
          amount: null,
          tax: null,
          serviceCharge: null,
          subtotal: null,
          billingMethod: [],
          lastAmount: null,
          lastBillTime: null
        },
        BillingList: [], //开票方式列表
        ticketTypeList: [{
          list: []
        }], //票种列表
        BillingConList: [{
          list: []
        }], //开票内容列表
        projectKeyList: [{
          list: []
        }],
        isExcess: false, //单张是否超或50w
        showLogin: false,
        loginForm: {
          qymc: '', //企业名称
          nsrsbh: '', //纳税人识别号
          areaid: '', //行政区划代码
          ljlx: 'PC', //链接类型 PC、H5
          rzcghddz: '', //认证成功回调地址(base64编码)
          ycsbhddz: '', //异常失败回调地址(base64编码
          fhdz: '', //H5页面返回地址(base64编码)
          zrrsf: 14, //自然人身份1：办税员2：法定代表人3：财务负责人6：领票人8：社保经办人14：开票员
        },
        showAuthentication: false,
        qrLoading: false,
        ewmlx: null,
        intervalNum: 0,
        QRCodeSrc: '',
        isTimeout: false,
        legList: [],
        subjectOfLegalAffairsId: '',
        kysxed: '', //可用授信额度
        zsxed: '', //总授信额度
        dqkyzpsl: '', //当前可用纸票数量
        limltIng: true,
        totalAmount: 0,
        cwxx: '',
        loginRules: {
          zrrsjh: {
            required: true,
            message: "请输入登录手机",
            trigger: "blur",
          },
          zrrmm: {
            required: true,
            message: "请输入登录密码",
            trigger: "blur",
          },
        },
      }
    },
    created() {
      if (this.$route.query.id != undefined && this.$route.query.id) {
        this.formQuery.remitIds = this.$route.query.id.split(',');
        this.getDetail();
      }
    },
    methods: {
      //初始化
      getDetail() {
        if (this.formQuery.remitIds) {
          let str = `GetInteriorInvoiceList`
          this.formQuery.remitIds.forEach((e, index) => {
            if (index == 0) {
              str = str + `?RemitIds=${e}`
            } else {
              str = str + `&RemitIds=${e}`
            }
          });
          xz.IvoiceGetFun(str).then(res => {
            if (res.status == "ok") {
              this.basicInfo = res.data;
              this.BillingList = res.data.billingMethod;
              this.getlegalsubjectlist();
            } else {
              this.BillingList = [];
              this.$message.error(res.msg)
            }
          });
        }
      },
      //选择开票方式
      changeBilling(val, item, index) {
        if (val) {
          let bill = this.BillingList.find(e => e.key == val);
          this.$set(item, 'taxRate', bill.taxRate);
          this.$set(item, 'billingItemName', bill.value);
          this.$set(item, 'ticketTypeId', '');
          if (bill.value.indexOf('差额') > -1 && bill.value.indexOf('差额征税-全额开票') == -1) {
            // let dd = math.format(
            //   math.add(
            //     math.bignumber(Number(this.basicInfo.amount)), math.bignumber(Number(this.basicInfo.tax))
            //   )
            // )
            item.Btype = 0; //差额
            item.main = null;
            item.takeOut = {
              billingItemDetailsId: '',
              pk: '',
              // replenishment: {
              //   quantity: null,
              //   unit: '',
              //   specification: ''
              // },
              details: [{
                projectName: '工资', //扣除项目
                deductionAmount: Number(this.basicInfo.amount)
              }, {
                projectName: '个税', //扣除项目
                deductionAmount: Number(this.basicInfo.tax)
              }]
            }
            this.calDeductionAmountSum('', item)
          } else {
            item.Btype = 1;
            item.takeOut = null;
            item.main = [{
              billingItemDetailsId: '', //开票内容id
              isTaxInclusive: true, //是否含税
              invoiceAmount: 0, //开票金额
              pk: '',
              // replenishment: {
              //   quantity: null,
              //   unit: '',
              //   specification: ''
              // }
            }]
            this.calMtpt('', item)
          }
          xz.GetTicketType(val).then(
            (res) => {
              if (res.status == "ok") {
                this.ticketTypeList[index].list = res.data;
              }
            })
        }
      },
      changeMerge(val, inv) {
        if (val) {
          inv.takeOut.billingItemDetailsId = '';
          inv.takeOut.pk = '';
          inv.main = [{
            billingItemDetailsId: '', //开票内容id
            isTaxInclusive: true, //是否含税
            invoiceAmount: this.basicInfo.serviceCharge, //开票金额
            // replenishment: {
            //   quantity: null,
            //   unit: '',
            //   specification: ''
            // }
          }]
        } else {
          inv.main = null
        }
      },
      //选择票种
      changeTicketTypeId(val, item, index) {
        let d = {
          key: item.billingItemId,
          TicketTypeId: val,
          Projectid: -1
        }
        xz.GetBillingItemDetails(d).then((res) => {
          if (res.status == "ok") {
            this.BillingConList[index].list = res.data;
          } else {
            this.BillingConList[index].list = [];
          }
        });
      },
      addContentHandle(inv) {
        let d = {
          billingItemDetailsId: '', //开票内容id
          isTaxInclusive: true, //是否含税
          invoiceAmount: 0, //开票金额
          // replenishment: {
          //   quantity: null,
          //   unit: '',
          //   specification: ''
          // }
        }
        inv.main.push(d)
      },
      dltContentHandle(inv, j) {
        inv.main.splice(j, 1);
        this.calMtpt('', inv)
      },
      //计算全额价税合计
      calMtpt(val, inv) {
        let sum = 0;
        inv.main.forEach(e => {
          let amount;
          if (!e.isTaxInclusive) {
            let tax = e.invoiceAmount * inv.taxRate;
            amount = math.format(
              math.add(
                math.bignumber(Number(e.invoiceAmount)), math.bignumber(Number(tax))
              )
            )
          } else {
            amount = e.invoiceAmount;
          }
          sum = math.format(
            math.add(
              math.bignumber(Number(sum)), math.bignumber(Number(amount))
            )
          )
        });
        this.$set(inv, 'mTpt', parseFloat(sum));
        this.totalAmount = sum;
        // if (sum > 500000) {
        //   this.isExcess = true;
        //   this.$message.error('单张发票金额不能超过50万');
        // } else {
        //   this.isExcess = false;
        // }
      },
      //计算差额价税合计
      calDeductionAmountSum(val, inv) {
        let sum = 0;
        inv.takeOut.details.forEach(e => {
          sum = math.format(
            math.add(
              math.bignumber(Number(sum)), math.bignumber(Number(e.deductionAmount))
            )
          )
        });
        if (inv.isMerge) {
          let sum2 = math.format(
            math.add(
              math.bignumber(Number(sum)), math.bignumber(Number(inv.main[0].invoiceAmount))
            )
          )
          if (inv.main[0].isTaxInclusive) {
            this.$set(inv, 'mTpt', parseFloat(sum2));
            this.totalAmount = sum2;
            // if (sum2 > 500000) {
            //   this.isExcess = true;
            //   this.$message.error('单张发票金额不能超过50万');
            // } else {
            //   this.isExcess = false;
            // }
          } else {
            let tax = inv.main[0].invoiceAmount * inv.taxRate;
            sum2 = math.format(
              math.add(
                math.bignumber(Number(sum2)), math.bignumber(Number(tax))
              )
            )
            this.$set(inv, 'mTpt', parseFloat(sum2));
            this.totalAmount = sum2;
            // if (sum2 > 500000) {
            //   this.isExcess = true;
            //   this.$message.error('单张发票金额不能超过50万');
            // } else {
            //   this.isExcess = false;
            // }
          }
        } else {
          this.$set(inv, 'mTpt', parseFloat(sum));
          this.totalAmount = sum;
          // if (sum > 500000) {
          //   this.isExcess = true;
          //   this.$message.error('单张发票金额不能超过50万');
          // } else {
          //   this.isExcess = false;
          // }
        }
      },
      //添加扣除部分
      addKcItem(inv) {
        let d = {
          projectName: '', //扣除项目
          deductionAmount: 0
        }
        inv.takeOut.details.push(d)
      },
      delKcItem(inv, i) {
        inv.takeOut.details.splice(i, 1);
        this.calDeductionAmountSum('', inv);
      },
      applyMore() {
        let d = {
          index: this.formQuery.details.length + 1,
          billingItemId: '', //开票方式
          isMerge: false, //是否合并
          ticketTypeId: '', //票种
          taxRate: null,
          billingItemName: '',
          mTpt: 0,
          main: [{
            billingItemDetailsId: '', //开票内容id
            isTaxInclusive: true, //是否含税
            invoiceAmount: 0, //开票金额
            pk: '',
            // replenishment: {
            //   quantity: null,
            //   unit: '',
            //   specification: ''
            // }
          }],
          takeOut: {
            billingItemDetailsId: '',
            pk: '',
            // replenishment: {
            //   quantity: null,
            //   unit: '',
            //   specification: ''
            // },
            details: [{
              projectName: '', //扣除项目
              deductionAmount: 0
            }]
          }
        }
        this.formQuery.details.push(d);
        let l = {
          list: []
        }
        let l2 = {
          list: []
        }
        let l3 = {
          list: []
        }
        this.ticketTypeList.push(l);
        this.BillingConList.push(l2);
        this.projectKeyList.push(l3);
      },
      delItem() {
        this.formQuery.details.splice(this.formQuery.details.length - 1, 1);
        this.ticketTypeList.splice(this.formQuery.details.length - 1, 1);
        this.BillingConList.splice(this.formQuery.details.length - 1, 1);
        this.projectKeyList.splice(this.formQuery.details.length - 1, 1);
        this.$message.success('删除成功！')
      },
      beforeSubmit(status) {
        // 遍历每一张发票明细
        for (let i = 0; i < this.formQuery.details.length; i++) {
          const inv = this.formQuery.details[i];
          // 仅当存在 main 数组且长度大于0时处理（通常对应全额开票或合并开票）
          if (inv.Btype == 1) {
            // 1. 获取第一个元素的 pk 作为基准
            const firstPk = inv.main[0].pk;

            // 2. 判断 main 数组中所有元素的 pk 是否与第一个相同
            // 注意：如果 pk 为空字符串或 null，也视为一种“一致”状态，但业务上可能需要非空校验
            const isAllSame = inv.main.every(item => item.pk === firstPk);

            if (isAllSame) {
              // 3. 如果一致，赋值给同级的 projectKey
              // 如果希望只有当 pk 有值时才赋值，可以加判断: if (firstPk) inv.projectKey = firstPk;
              this.$set(inv, 'projectKey', firstPk);
              if (status) {
                this.submit(status)//手工登记开票
              } else {
                this.beforeSubmit2(status)
              }
            } else {
              // 可选：如果不一致，给出提示并阻止提交
              this.$message.warning(`第 ${i + 1} 张发票的项目申报代码不一致`);
            }
          } else {
            this.$set(inv, 'projectKey', inv.takeOut ? inv.takeOut.pk : '');
            this.beforeSubmit2(status)
          }
        }

      },
      beforeSubmit2(status) {
        if (!this.limltIng) {
          let num = 0;
          this.formQuery.details.forEach(e => {
            num = math.format(
              math.add(
                math.bignumber(Number(num)), math.bignumber(Number(e.mTpt))
              )
            )
          });
          console.log('dsads', num)
          if (Number(num) > Number(this.kysxed)) {
            this.$message.error('可用授信额度不足！')
          } else {
            this.submit(status)
          }
        } else {
          this.$message.warning('查询可用额度中，请稍等')
        }
      },
      submit(status) {
        // if (!this.isExcess) {
        this.isBtnLoading = true;
        this.formQuery.isOffline = status;
        xz.IvoiceFun(this.formQuery, "SetInteriorInvoiceSave").then((res) => {
          if (res.status == "ok") {
            this.$message.success(status ? "手工登记开票成功" : "开票成功");
            this.isBtnLoading = false;
            this.isSuccess = true;
            setTimeout(() => {
              this.backHandle()
            }, 1000);
          } else {
            this.$message.error(res.msg);
            this.isBtnLoading = false;
            if (res.msg.indexOf('扫脸认证已超时') > -1) {
              setTimeout(() => {
                this.showAuthentication = true
              }, 500);
            } else if (res.msg.indexOf('登录') > -1 || res.msg.indexOf('不存在') > -1) {
              setTimeout(() => {
                this.showLogin = true;
              }, 500);
            }
          }
        });
        // } else {
        //   this.$message.error('单张发票金额不能超过50万!');
        // }
      },
      // 取消
      backHandle() {
        window.close()
      },
      //获取法务主体列表
      getlegalsubjectlist() {
        let data = {
          keyWord: '',
          pageSize: '10000',
          UserId: Cookies.get("userid-b")
        }
        xz.BasicFun(data, 'GetSubjectOfLegalAffairs').then(res => {
          if (res.status == 'ok') {
            this.legList = res.data;
            let item = this.legList.find(e => e.value == this.basicInfo.seller);
            this.subjectOfLegalAffairsId = item.key;
            this.getQYinfo();
          } else {
            this.legList = [];
          }
        })
      },
      getQYinfo() {
        // let item = this.legList.find(e => e.value = val);
        xz.GetCorporationData(this.subjectOfLegalAffairsId).then((res) => {
          if (res.status == "ok") {
            // this.$set(this.loginForm, 'nsrsbh', res.data.taxNum);
            let encode = encodeURI(`https://emp.joball.net/internalInvoice?status=back&subId=${this.subjectOfLegalAffairsId}&id=${this.$route.query.id}`);
            console.log(encode)
            let base64 = btoa(encode)
            this.loginForm = {
              qymc: res.data.strLegalsubName,
              nsrsbh: res.data.taxNum,
              areaid: res.data.value,
              ljlx: 'PC', //链接类型 PC、H5
              rzcghddz: base64, //认证成功回调地址(base64编码)
              ycsbhddz: base64, //异常失败回调地址(base64编码
              fhdz: base64,
              zrrsf: 14, //自然人身份1：办税员2：法定代表人3：财务负责人6：领票人8：社保经办人14：开票员
              zrrsjh: '',
              zrrmm: '',
            };
            this.getLimit();
            if (this.$route.query.status == 'back' && this.$route.query.subId != undefined) {
              this.PostThirdParty_subscribe()
            }
          } else {
            this.loginForm.qymc = '';
            this.loginForm.nsrsbh = '';
            this.$message.warning('获取该主体信息异常')
          }
        })
      },
      confirmLogin() {
        this.$refs['loginForm'].validate((valid) => {
          if (valid) {
            this.isBtnLoading = true;
            xz.IvoiceFun(this.loginForm, "PostThirdParty_asyncInit").then((res) => {
              if (res.status == "ok") {
                this.confirmLogin2()
              } else {
                this.$message.error(res.msg)
                this.isBtnLoading = false;
              }
            })
          }
        })
      },
      confirmLogin2() {
        xz.IvoiceFun(this.loginForm, "PostThirdParty_generate").then((res) => {
          if (res.status == "ok") {
            this.showLogin = false;
            this.isBtnLoading = false;
            window.open(res.data, '_blank')
          } else {
            this.$message.error(res.msg);
            this.isBtnLoading = false;
          }
        });
      },
      PostThirdParty_subscribe() {
        let dd = [{
          nsrsbh: this.loginForm.nsrsbh, //纳税人识别号
          areaid: this.loginForm.areaid, //行政区划代码
          sqlx: 2, //授权类型1:月授权2：年授权
          sfzdxd: false, //是否自动续订
          isf: false //是否强制订阅
        }]
        xz.IvoiceFun(dd, "PostThirdParty_subscribe").then((res) => {
          if (res.status == "ok") {
            this.$router.push({
              path: this.$route.path,
              query: {
                activeName: this.activeName,
                status: 'ok'
              }
            });
            this.isBtnLoading = false;
            // this.$message.success("登录成功");
            this.showLogin = false;
            // this.getQRCode();
            this.showAuthentication = true; //认证
          } else {
            this.isBtnLoading = false;
            this.$message.error(res.msg);
            this.$router.push({
              path: this.$route.path,
              query: {
                status: 'err'
              }
            });
          }
        });
      },
      changeEwmlx() {
        this.QRCodeSrc = '';
        this.getQRCode();
      },
      //获取二维码
      getQRCode() {
        this.qrLoading = true;
        this.isTimeout = false;
        let data = {
          nsrsbh: this.loginForm.nsrsbh,
          areaid: this.loginForm.areaid,
          ewmlx: this.ewmlx
        }
        xz.IvoiceFun(data, 'PostThirdParty_queryAuthQrCode').then(res => {
          if (res.status == 'ok') {
            this.qrLoading = false;
            if (res.data.cwxx) {
              this.$message.error(res.data.cwxx)
            } else {
              this.QRCodeSrc = res.data.ewm;
              this.showAuthentication = true;
              this.times = 0;
              this.rzid = res.data.rzid;
              clearInterval(this.interval);
              this.intervalNum = 0;
              setTimeout(() => {
                this.getQRStatus();
              }, 8000);
            }
          } else {}
        })
      },
      //获取扫码情况
      getQRStatus() {
        this.times++;
        xz.PostThirdParty_queryAuthQrCode(this.rzid).then(res => {
          if (res.status == 'ok') {
            if (res.data == '进行中' && this.times < 59) {
              setTimeout(() => {
                this.getQRStatus()
              }, 2000);
            } else {
              if (res.data.rzzt == '2') {
                this.showAuthentication = false;
                this.$message.success('认证成功');
                this.getLimit();
                clearInterval(this.interval);
              } else if (res.data.rzzt == '3') {
                this.$message.success('认证超时');
                this.isTimeout = true;
                clearInterval(this.interval);
              }
            }
          } else {
            this.$message.error(res.msg)
          }
        })
      },
      Refresh() {
        this.times++;
        this.getQRStatus();
        console.log('intervalNum', this.intervalNum)
        if (this.times == 59) {
          this.times = 0;
          this.isTimeout = true;
          clearInterval(this.interval);
        }
      },
      //获取主体额度
      getLimit() {
        this.limltIng = true;
        let d = {
          qymc: this.loginForm.qymc,
          nsrsbh: this.loginForm.nsrsbh,
          areaid: this.loginForm.areaid,
        }
        xz.IvoiceFun(d, 'PostThirdParty_queryBillingDataOverview').then(res => {
          if (res.status == 'ok') {
            try {
              this.kysxed = res.data.kysxed; //可用授信额度
              this.zsxed = res.data.zsxed; //总授信额度
              this.dqkyzpsl = res.data.dqkyzpsl; //当前可用纸票数量
              this.limltIng = false;
              if (res.data.cwxx != null && res.data.cwxx != '') {
                this.cwxx = res.data.cwxx;
                if (res.data.cwxx.indexOf('登录') > -1) {
                  this.showLogin = true;
                }
              } else {
                this.cwxx = '';
              }
            } catch (e) {
              console.log(e)
              this.$message.error('获取额度信息异常')
            }
          } else {
            this.$message.error(res.msg)
          }
        })
      },
      changeBillingItemDetailsId(val, row, i) {
        this.$set(row, 'pk', '')
        let item = this.BillingConList[i].list.find(e => e.key == val);
        this.projectKeyList[i].list = item.projectKey;
        if (item.projectKey.length > 0) {
          this.$set(row, 'pk', item.projectKey[0].key)
        }
      },
    },
  }
</script>

<style scoped>
  .mt15 {
    margin-top: 15px;
  }

  .r_edit_title {
    display: flex;
    align-items: center;
    font-size: 16px;
    line-height: 26px;
    font-weight: bold;
    color: #000;
    /* border-bottom: 1px solid #DCDFE6; */
  }

  .p_employee_box {
    background-color: #fff;
    padding: 15px 10px;
  }

  .line_box {
    width: 3px;
    height: 16px;
    background-color: #19bd92;
    margin-right: 4px;
  }

  .com_style {
    background-color: #e8f7f7;
  }

  .pt20 {
    padding-top: 20px;
  }

  .form_item {
    min-width: 240px;
  }

  .btn_box {
    display: flex;
    justify-content: center;
    margin-top: 30px;
  }

  .seller {
    font-size: 14px;
    color: #606266;
    line-height: 40px;
    padding-left: 15px;
  }

  .Amount {
    font-size: 14px;
    font-weight: bold;
    padding-left: 15px;
    margin-top: 10px;
  }

  .redFont {
    color: red;
  }

  .otherAmount {
    font-size: 13px;
    font-weight: 400;
  }

  .mTpt {
    text-align: right;
    padding-right: 50px;
  }

  .deductionBox {
    padding-left: 75px;
  }

  .applyMore {
    font-size: 18px;
    font-weight: bold;
    margin-left: 30px;
  }

  .delete_icon {
    font-size: 20px;
  }

  .chkBox {
    margin-top: 15px;
    padding-top: 10px;
    border-top: 2px dashed #ccc;
    padding-left: 10px;
    font-size: 14px;
  }

  .qrTips {
    text-align: center;
    margin-top: 10px;
    font-size: 14px;
  }

  .limltTitle {
    min-width: 140px;
    text-align: right;
    font-size: 14px;
    line-height: 32px;
  }

  .limlt {
    font-weight: bold;
    font-size: 14px;
    min-width: 120px;
    padding-left: 5px;
    line-height: 32px;
  }

  .limltBox {
    height: 40px;
  }

  .cwxx {
    color: red;
    font-size: 16px;
    padding: 0 20px;
  }
</style>
<style>
  .page_internalInvoice .injuryTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_internalInvoice .el-radio {
    margin-right: 15px;
  }

  .page_internalInvoice .p_employee_list .el-form-item {
    margin-bottom: 10px;
  }

  .page_internalInvoice .el-input__icon {
    height: 32px;
    line-height: 32px;
  }
</style>